import { RouterProvider } from "@/providers/Router.Provider.tsx";
import { useStore } from "@/stores/useStore.ts";
import { useEffect } from "react";

function App() {
  const authListener = useStore((s) => s.authListener);
  useEffect(() => {
    authListener();
  }, []);
  return <RouterProvider />;
}

export default App;
